// Start of Talkdesk Code
if (window.process !== undefined) { delete window.process; }
window.IS_NODE = false;
window.IS_BROWSER = true;
var webchat;
((window, document, node, props, configs) => {
    if (window.TalkdeskChatSDK) {
        console.error("TalkdeskChatSDK already included");
        return;
    }
    var divContainer = document.createElement("div");
    divContainer.id = node;
    document.body.appendChild(divContainer);
    var src = `https://talkdeskchatsdk.talkdeskapp.com/talkdeskchatsdk.js`;
    var script = document.createElement("script");
    var firstScriptTag = document.getElementsByTagName("script")[0];
    script.type = "text/javascript";
    script.charset = "UTF-8";
    script.id = "tdwebchatscript";
    script.src = src;
    script.async = true;
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    script.onload = () => {
        webchat = TalkdeskChatSDK(node, props);
        webchat.init(configs);
    };
})(
    window,
    document,
    "tdWebchat",
    { touchpointId: "f90a6738573c49be9602eb6e774b70ee", accountId: "", region: "td-eu-1" },
    {
        enableValidation: false, enableEmoji: true, enableUserInput: true, enableAttachments: true, styles: {
            "botAnchorTextColor": "#a661ff", "botAnchorTextColorVisited": "#d3b3fd", "avatarBackgroundColor": "#edf4fc", "avatarForegroundColor": "#edf4fc", "avatarBorderColor": "#edf4fc", "botBackgroundColor": "#f2f4f5", "botIcon": "https://prd-cdn-talkdesk.talkdesk.com/cdn-assets/latest/talkdesk/product/app-icons/sms.svg", "botTextColor": "#000000", "carouselTextColor": "#475059", "chatIcon": "https://www.anglicarevic.org.au/wp-content/themes/default/static/img/chat-now_ssbi.png", "chatHoverThemeColor": "transparent", "chatPlaceholder": "Type a message...", "chatTitle": "Student Broadband Chat", "chatTitleTextColor": "#ffffff", "chatTitleIcon": "https://prd-cdn-talkdesk.talkdesk.com/cdn-assets/latest/talkdesk/product/app-icons/sms.svg", "chatSubtitle": "Student Internet Program", "chatSubtitleTextColor": "#ffffff", "replyBackgroundColor": "transparent", "replyBorderColor": "#005cde", "replyHoverTextColor": "#edf4fc", "replyTextColor": "#005cde", "userAnchorTextColor": "#ffc5fe", "userAnchorTextColorVisited": "#d3b3fd", "userBackgroundColor": "#6F60AA", "userTextColor": "#ffffff", "welcomeMessageTitleFontSize": "18px", "welcomeMessageBackgroundColor": "#008595", "welcomeMessageContentFontSize": "12px",
            "customMessageBackgroundColor": "#D6BFD4", "customMessageNoBubbleColor": "#D6BFD4",
            "customButtonColor": "#ffffff", "customButtonBackgroundColor": "#008595", "customButtonBorderColor": "#5F0F57", "botIcon": "https://prd-cdn-talkdesk.talkdesk.com/cdn-assets/latest/talkdesk/product/app-icons/sms.svg", "customFieldLabelColor": "#000000", "customFieldInputColor": "#000000", "customFieldInputBackgroundColor": "#FFFFFF",
            "customFieldInputPlaceholder": "Type", "customDropdownLabelColor": "#000000",
            "customDropdownInputColor": "#000000", "customDropdownInputBackgroundColor": "#FFFFFF",
            "customDropdownInputPlaceholder": "Select", "StartChatButtonbackgroundcolor": "#F35D4A", "StartChatButtonbackbordercolor": "#AA543B"
        }
    }
);
// End of Talkdesk Code
